
var expansionPanel = () => {
    var $panelWrapper = $('.panel-group.expansion'),
         $panel =    $('.panel-group.expansion .panel'),
      $clickTarget = $('.panel-group.expansion .panel .panel-title > a'),
      $panelCollapse = $('.panel-group.expansion .panel-collapse')

    $clickTarget.on('click',function(){
       $panel.removeClass('active');
      if($(this).hasClass('collapsed')){
        $(this).parents('.panel').addClass('active')
      } else{
          $(this).parents('.panel').removeClass('active');
      }
    });

};

var activeAccordion = () => {
  // if ($('.collapse')[0]) {
  //     $('.collapse').on('show.bs.collapse', function (e) {
  //         $(this).closest('.panel').addClass('active');
  //     });
  //     $('.collapse').on('hide.bs.collapse', function (e) {
  //         $(this).closest('.panel').removeClass('active');
  //     });
  //     $('.collapse.in').each(function(){
  //         $(this).closest('.panel').addClass('active');
  //     });
  // }
};


export {expansionPanel,activeAccordion}



// WEBPACK FOOTER //
// ./js/modules/panelExpand.js